/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseV2,
    PressReleaseV2FromJSON,
    PressReleaseV2FromJSONTyped,
    PressReleaseV2ToJSON,
} from './PressReleaseV2';

/**
 * 
 * @export
 * @interface SearchPublishedDateOrderPressReleaseResponseData
 */
export interface SearchPublishedDateOrderPressReleaseResponseData {
    /**
     * 
     * @type {Array<PressReleaseV2>}
     * @memberof SearchPublishedDateOrderPressReleaseResponseData
     */
    pressReleases: Array<PressReleaseV2>;
    /**
     * 次のデータを取得する開始点となる識別子. {unix_timestamp}_{company_id}_{release_id}という形式
     * @type {string}
     * @memberof SearchPublishedDateOrderPressReleaseResponseData
     */
    nextCursor: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchPublishedDateOrderPressReleaseResponseData
     */
    totalCount: number;
}

export function SearchPublishedDateOrderPressReleaseResponseDataFromJSON(json: any): SearchPublishedDateOrderPressReleaseResponseData {
    return SearchPublishedDateOrderPressReleaseResponseDataFromJSONTyped(json, false);
}

export function SearchPublishedDateOrderPressReleaseResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPublishedDateOrderPressReleaseResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleases': ((json['press_releases'] as Array<any>).map(PressReleaseV2FromJSON)),
        'nextCursor': json['next_cursor'],
        'totalCount': json['total_count'],
    };
}

export function SearchPublishedDateOrderPressReleaseResponseDataToJSON(value?: SearchPublishedDateOrderPressReleaseResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_releases': ((value.pressReleases as Array<any>).map(PressReleaseV2ToJSON)),
        'next_cursor': value.nextCursor,
        'total_count': value.totalCount,
    };
}

